import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useYear from "../../../../hooks/Year";
import { getRequestGraphSection, reloadAllSection, reloadSectionBySectionId } from "../../../../config";
import { MessageAnt } from "../../../../redux/slices/ui/uiAction";
import { MessageType } from "../../../../types/messageType";

const useGraphInternal = () => {
    const auth = useSelector((state) => state.auth);

    const [tasks, setTasks] = useState({
        sections: [],
        graph: []
    });
    const [isLoading, setIsLoading] = useState(false);
    const { listOfYears, updateYear, year } = useYear(5);
    const [selectedSection, setSelectedSection] = useState(0);
    const [modalInfo, setmodalInfo] = useState({
        visible: false,
        data: {},
        type: "create" // create | update | delete
    })


    const realoadPage = useCallback(
        () => {
            setIsLoading(true);
            getRequestGraphSection(year)
                .then(({ status, payload: sections }) => {
                    if (status !== 0) return;
                    setTasks({
                        sections,
                        graph: sections.map((section, index) => {
                            return {
                                id: `${index}-${section.name}`,
                                label: section.name,
                                value: section.totalTimeSpent,
                                color: section.color || "#ccc"
                            }
                        })
                    });
                })
                .catch((error) => console.error(error))
                .finally(() => setIsLoading(false));
        },
        [year],
    )

    const openModalEditSection = (data) => {
        setmodalInfo({
            visible: true,
            data,
            type: "update"
        })
    };

    const openModalCreateSection = () => {
        setmodalInfo({
            visible: true,
            data: {},
            type: "create"
        })
    };

    const openModalDeleteSection = (data) => {
        setmodalInfo({
            visible: true,
            data,
            type: "delete"
        })
    };

    const closeModal = useCallback(
        () => {
            setmodalInfo({
                visible: false,
                data: {},
                type: "create"
            })
        },
        [],
    )

    const handleReaload = useCallback(
        async () => {
            setIsLoading(true);
            const { status } = await reloadAllSection(year);
            if (status !== 0) {
                setIsLoading(false);
                MessageAnt(MessageType.error, `Error al recargar todas las secciones`);
                return;
            }
            MessageAnt(MessageType.success, `Se recargo todas las secciones`);
            realoadPage();
        },
        [realoadPage, year],
    )

    const handleRealoadBySection = useCallback(
        async (data) => {
            const { sectionId, name } = data;
            setIsLoading(true);
            const { status } = await reloadSectionBySectionId(sectionId)
            if (status !== 0) {
                setIsLoading(false);
                MessageAnt(MessageType.error, `Error al recargar seccion ${name}`);
                return;
            }
            MessageAnt(MessageType.success, `Se recargo seccion ${name}`);
            realoadPage();
        },
        [realoadPage],
    )

    const onFinishForm = useCallback(() => {
        realoadPage()
        closeModal()
    }, [realoadPage, closeModal])

    const handleSectionChange = (index) => {
        setSelectedSection(index);
    };

    useEffect(() => {
        if (!auth.authentication) return;
        realoadPage()
    }, [
        realoadPage,
        auth.authentication
    ]);

    return {
        hasAction: auth.isSuperAdmin,
        tasks,
        isLoading,
        listOfYears,
        updateYear,
        year,
        selectedSection,
        handleSectionChange,
        openModalEditSection,
        openModalCreateSection,
        handleReaload,
        handleRealoadBySection,
        modalInfo,
        closeModal,
        openModalDeleteSection,
        onFinishForm
    }
}

export default useGraphInternal